/*
 * render-template-string.ts
 *
 * Created by Dr. Maximillian Dornseif 2022-01-19 in huwawi3backend 12.3.1
 * Copyright (c) 2022 Maximillian Dornseif
 */

import template from 'es6-template-strings'

export function renderTemplateString(templateString: string, data: Record<string, any>): string {
  try {
    return template(templateString, data)
  } catch (error) {
    return `Template Fehler in "${templateString}" mit ${JSON.stringify(Object.keys(data || {}))}: ${
      error.error
    }`
  }
}
